module.exports = __webpack_public_path__ + "img/ras_bg@2x.f16b877c.png";